/**
 * UNE QUESTION, DEUX BOUTONS.
 *
 * Ne sert qu'a ce qui ne se defait pas d'un geste: l'administrateur qui demolit
 * la construction d'un AUTRE. Il le faisait d'un seul tap, sans rien demander,
 * et le 13 octobre l'ecole d'un joueur est tombee ainsi, en plein essai au
 * telephone — il a fallu la reposer a la main depuis la sauvegarde. Le joueur
 * ordinaire, lui, ne demolit que les siennes et garde son tap unique.
 *
 * Un panneau comme les autres: la touche « retour » le ferme, et le fermer
 * sans choisir vaut « non ».
 */
import { journal } from '../log/journal.ts'
import { Panneau, bouton, el } from './commun.ts'

export class PanneauConfirmation extends Panneau {
  private onOui: (() => void) | null = null

  constructor(parent: HTMLElement) {
    super(parent, 'construire', 'Confirmer', '⚠️')
  }

  demander(question: string, detail: string, libelle: string, onOui: () => void): void {
    this.onOui = onOui
    this.viderCorps()
    this.viderPied()
    this.corps.append(el('p', 'confirmation__question', question))
    this.corps.append(el('p', 'note', detail))
    this.pied.append(
      bouton(
        'Annuler',
        () => {
          journal.input('construire', `confirmation refusee: ${question}`)
          this.fermer()
        },
        'bouton--sombre',
      ),
    )
    this.pied.append(bouton(libelle, () => this.accepter(question)))
    journal.input('construire', `confirmation demandee: ${question}`)
    this.afficher(question)
  }

  private accepter(question: string): void {
    journal.input('construire', `confirmation acceptee: ${question}`)
    const rappel = this.onOui
    this.onOui = null
    this.fermer()
    rappel?.()
  }

  protected override surFermeture(): void {
    this.onOui = null
    super.surFermeture()
  }
}
